import {
  VStack,
  Button,
  HStack,
  useMediaQuery,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";

export default function DayPicker({ currentDayIndex, setCurrentDayIndex }) {
  const [isLargerThanMd] = useMediaQuery("(min-width: 500px)");
  const bgColor = useColorModeValue("#5b8a7b", "#E9A6A6");
  const highlightedTextColor = useColorModeValue("white", "black");

  // get the labels for the date picker
  const shortDays = ["Sat", "Sun", "Mon", "Tue", "Wed"];
  const longDays = ["Saturday", "Sunday", "Monday", "Tueday", "Wednesday"];
  const days = isLargerThanMd ? longDays : shortDays;

  return (
    <VStack spacing="10px" minW="100%">
      <HStack
        justify="space-between"
        minW="100%"
        spacing="0px"
        flexWrap="wrap"
        justifyContent="space-around"
      >
        {days.map((day, index) => (
          <Button
            key={index}
            onClick={() => setCurrentDayIndex(index)}
            minh="40px"
            flex="1"
            variant={index === currentDayIndex ? "solid" : "outline"}
            bg={index === currentDayIndex ? bgColor : ""}
            color={index === currentDayIndex ? highlightedTextColor : ""}
            borderLeftRadius={index !== 0 ? "0px" : "10px"}
            borderRightRadius={index !== 4 ? "0px" : "10px"}
            fontSize="sm"
            h="34px"
          >
            <Text fontFamily="Lilita One" fontWeight="light">
              {day}
            </Text>
          </Button>
        ))}
      </HStack>
    </VStack>
  );
}
